<template>
  <div class="source-content-tabs">
    <div class="source-types">
      <button
        class="tab-btn tab-btn--outlined"
        :class="{
          active: selectedTab === 'new',
        }"
        data-test="producer-assets-newPollsTab"
        @click="selectedTab = 'new'"
      >
        New
      </button>

      <button
        class="tab-btn tab-btn--outlined"
        :class="{
          active: selectedTab === 'classic',
        }"
        data-test="producer-assets-classicPollsTab"
        @click="selectedTab = 'classic'"
      >
        Classic
      </button>
    </div>

    <component :is="currentTabComponent" />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
  name: 'PollTabs',
  data() {
    return {
      selectedTab: 'new',
    };
  },
  computed: {
    currentTabComponent() {
      switch (this.selectedTab) {
        case 'classic':
          return defineAsyncComponent(() => import('../SmartPanels.vue'));
        default:
          return defineAsyncComponent(() => import('./Polls.vue'));
      }
    },
  },
};
</script>
